import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AsyncSelect from 'react-select/async';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import { setData, getData, resetTool, resetAlfredQuestions, handle_restricted_Filter, setKpiColumnConfig, setTab, setGlobalFilters ,getGlobalFilters, setQuestion} from '../../actions/index';
import { DBService } from '../SummaryComponents/component/IndexedDB';
import MonitoringTableDataComponent from './MonitoringTableDataComponent';
import MonitoringGridComponent from './MonitoringGridComponent';
import PaginationComponent from '../commonComponents/PaginationComponent';
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
import ModalComponent from '../../../adminpanel/components/commonComponents/ModalComponent';
import LoadingComponent from '../commonComponents/LoadingComponent';

var start_date = null, end_date = null, selectedToolData = null
var globalFilterModal = { "id": "globalFilterModal", "form_name": "globalFilter", "form_id": "globalFilterForm", "button_name": "Save", "buttonType": "submit", "display": true }, cacheGlobalFilter = {}; 

class DashBoardMonitoring extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tabId: getParameters('tab') ? getParameters('tab') : props.tab ? props.tab : 'datasets',
            toggleGridView: window.localStorage.getItem('userView') == 'false' ? false : true,
            data: { reportsData: [], reportDates: {} },
            currentPage: 1,
            searchValue: '',
            sortValue: '',
            datasetFilterToolId: '',
            dashboardFilterName: '',
            globalFilterValues: null,
            modalToView: {},
        }
        this.serachInputRef = React.createRef()
        this._db = new DBService();
        this.getReportsData = this.getReportsData.bind(this)
        this.setData = this.setData.bind(this)
        this.handleRightClickOption = this.handleRightClickOption.bind(this)
        this.globalFilterInputHandler = this.globalFilterInputHandler.bind(this)
        this.updateGlobalFilters = this.updateGlobalFilters.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
        this.getGlobalFilters = this.getGlobalFilters.bind(this)
    }
    componentWillReceiveProps(nextProps) {
        this.setState(nextProps);
    }
    componentDidMount() {
        this.setState({ globalFilterValues: this.props.globalFilters });
    }
    componentWillMount() {
        if (this.state.tabId == 'reports' && Object.keys(this.state.data.reportsData).length == 0) {
            this.getReportsData()
        }
        let selectedToolId = JSON.parse(localStorage.Dataset).toolId 
        this.setState({
            datasetFilterToolId:selectedToolId
        })
    }
    
    setData = (data, view, url = null, tab) => {
        let that = this;
        let indexedDB = this._db
        IDBStoreNames && IDBStoreNames.forEach((e) => {
            indexedDB.deleteByTimestamp(e, data.toolId)
        })
        window.localStorage.setItem('Dataset', JSON.stringify({ "siteId": data.siteId }));
        this.props.resetTool({ "siteId": data.siteId })
        this.props.resetAlfredQuestions()
        this.getData(data, url, view, tab);
        this.props.handleLoadingStatus(true)
    }

    getData(actual_data, url = null, view, tab) {
        if (this.props.alfred_question != '') {
            this.props.setQuestion({ alfred_question: "" });
        }
        var that = this;
        let params = {
            siteId: actual_data.siteId,
            toolId: actual_data.toolId,
            filterType: 'all',
            propValues: null,
            filterValues: null,
            type: null
        }
        let postData = { userId: this.props.authData.userId }
        CallAPI("POST", '/app/initialRequest', postData, params, 0, function (res) {
            checkIfSessionTimedOut(res)
            var userFeature = getUpdatedUserFeature(res.userFeature);
            var dateObject = res.dateTime[0];
            var final_data = {
                endDate: dateObject.dashboardEndTime,
                startDate: dateObject.dashboardStartTime,
                endTime: dateObject.endTime,
                startTime: dateObject.startTime,
                userFeature: userFeature,
                dashbordGroups: res.dashbordGroups,
                dashbordGroupsNames: res.dashboardGroupsName,
                userDBSetting: res.userDBSetting,
                summarizationDetails: res.summarizationDetails,
                getAllUsers: res.getAllUsers,
                getNotification: res.getNotification,
                getuserprofile: res.getuserprofile,
                chartDefault: res.chartDefault,
                alfred: { intent: res.intent, metric: res.metric, property: res.property, questions: res.questions, location: res.location, chart_array: res.chart },
                kpiMonitoringFunctions: res.kpiMonitoringFunctions,
                ...actual_data
            }
            that.props.setData(final_data)
            that.props.handle_restricted_Filter({ restrictedFilter: res.restrictedFilter })
            let defaultFunctions = []
            res.defaultKPIMonitoringFunctions && res.defaultKPIMonitoringFunctions.map((innerData) => {
                defaultFunctions.push(innerData.value)
            })

            let global_filter = res.globalFilter && res?.globalFilter[0] && res?.globalFilter[0].temporary_filter && isJson(res.globalFilter[0].temporary_filter) ? JSON.parse(res.globalFilter[0].temporary_filter) : []
            that.props.setGlobalFilters(global_filter)
            that.props.setTab(tab)
            window.localStorage.setItem('Dataset', JSON.stringify(actual_data));
            window.localStorage.setItem('dashboardConfigKey', {});
            that.props.setKpiColumnConfig(defaultFunctions)
            setTimeout(function () {
                if (url) {
                    that.props.history.push(url);
                } else {
                    let link = document.createElement('a')
                    link.href = '/landingPage';
                    that.props.history.push(`/landingPage`);
                }
            }, 2000);



        }, this.props.authData)
    }
    toggleMainButton(e) {
        // let value = e.target.checked
        // this.setState((currentState) => ({
        //     toggleGridView: !currentState.toggleGridView
        // }));
        window.localStorage.setItem('userView', e)

        this.setState({
            toggleGridView: e,
        })
        this.handleTabId(this.state.tabId)
    }
    getReportsData = (toolId = '', startDate = null, endDate = null, searchKeyword = '', perPage = 20, page = 1, sortBy = '', sortOrder = '', sortValue = '', dashboardGroup = '') => {
        let that = this
        let isCustomReportingTrue = this.props.authData ? JSON.parse(this.props.authData.extraInfo)?.customReporting ? JSON.parse(this.props.authData.extraInfo)?.customReporting : false : null
        let dashboardGroupSplit = dashboardGroup ? dashboardGroup.split('_') : ''
        that.setState({
            data: { reportsData: [] }, currentPage: page, datasetFilterToolId: toolId, searchValue: searchKeyword, sortValue: sortValue, sortBy: sortBy, sortOrder: sortOrder, dashboardFilterName: dashboardGroupSplit[1] && (toolId !== dashboardGroupSplit[1]) ? "" : dashboardGroup
        });
        let params = {
            "siteId": that.props.authData.siteId,
            'searchKeyword': searchKeyword,
            'toolId': toolId,
            'dashboard_group': dashboardGroupSplit[1] && (toolId !== dashboardGroupSplit[1]) ? "" : dashboardGroupSplit[0],
            'perPage': perPage,
            'page': page,
            'sortBy': sortBy,
            'sortOrder': sortOrder
        }
        if (!that.state.toggleGridView && isCustomReportingTrue == true || isCustomReportingTrue == "true") {
            if (startDate && endDate) {
                let startDateObj = moment(startDate)
                let endDateObj = moment(endDate)
                params['startDate'] = startDateObj.format('YYYY-MM-DD');
                params['endDate'] = endDateObj.format('YYYY-MM-DD');
            } else if (getParameters('startDate') && getParameters('endDate')) {
                params['startDate'] = getParameters('startDate');
                params['endDate'] = getParameters('endDate');
            }
        }
        CallAPI('get', '/app/fetch_report_data', null, params, 0, function (response) {
            that.setState({
                data: {
                    reportsData: response,
                    reportDates: response.dates
                }
            });
            if (!that.state.toggleGridView) {
                let newURL = window.location.origin + window.location.pathname + `?tab=reports`
                if (start_date && end_date && isCustomReportingTrue == true || isCustomReportingTrue == "true") {
                    newURL = newURL + `&startDate=${start_date}&endDate=${end_date}`
                }
                history.pushState({}, null, newURL);
            }
        }, that.props.authData)
    }
    handleTabId = (routeName, breakdownData = null) => {
        let that = this
        let isCustomReportingTrue = JSON.parse(that.props.authData.extraInfo)?.customReporting ? JSON.parse(that.props.authData.extraInfo)?.customReporting : false
        var newURL = window.location.origin + window.location.pathname + `?tab=${routeName}`
        let workbookVal = breakdownData && breakdownData.dashboard_group ? `${breakdownData.dashboard_group}_${breakdownData.toolId}` : ''
        if (routeName == 'reports') {
            if (that.state.data?.reportsData?.filteredData != false || breakdownData != null || that.state.currentPage != 1) {
                this.getReportsData(breakdownData ? breakdownData.toolId : '', null, null, '', 20, 1, '', '', '', workbookVal)
            }
            if (start_date && end_date && isCustomReportingTrue == true || isCustomReportingTrue == "true") {
                newURL = newURL + `&startDate=${start_date}&endDate=${end_date}`
            }
        }
        if (document.getElementById('searchKeyword')) {
            document.getElementById('searchKeyword').value = ''
        }
        // if (document.getElementById('dataset_filter_form_data')) {
        //     document.getElementById('dataset_filter_form_data').value = ''
        // }
        // if (document.getElementById('sortByFilter_form_data')) {
        //     document.getElementById('sortByFilter_form_data').value = ''
        // }
        let selectedToolId = JSON.parse(localStorage.Dataset).toolId 
        history.pushState({}, null, newURL);
        this.setState({ tabId: routeName, searchValue: '', datasetFilterToolId: breakdownData ? breakdownData.toolId : selectedToolId ? selectedToolId : '', sortValue: '', sortBy: '', sortOrder: '', dashboardFilterName: workbookVal, currentPage: 1 });
    }
    handleRightClickOption = (onClickInfo = null, view = null, tab, id) => {
        let that = this
        let currentTab = tab ? tab : that.state.tabId
        let value = onClickInfo ? onClickInfo : gridOptions.api.getSelectedNodes()[0]['data']
        this.props.handleLoadingStatus(true)
        if (currentTab == "dashboards" || currentTab == 'reports') {
            if (id == 'manageAccess') {
                that.props.history.push({
                    pathname: '/admin/users',
                    state: { data: value }
                })
            } else {
                if (that.props.dataSet == {} || that.props.dataSet.toolId != value.toolId) {
                    let selectedDataset = that.props.dataResult.filter(val => val.toolId == value.toolId)
                    that.props.setTab(currentTab)
                    that.setData(selectedDataset[0], view, value.url, currentTab)
                    setTimeout(() => {
                        this.props.handleLoadingStatus(false)
                    }, 4000)
                } else {
                    let link = document.createElement('a')
                    link.href = value.url
                    // link.setAttribute('target', `_blank`)
                    setTimeout(() => {
                        this.props.handleLoadingStatus(false)
                    }, 4000)
                    link.click();
                }
            }
        } else if (currentTab === "datasets") {
            that.setData(value, view, null, currentTab)
        }
    }
    paginationEvent = (e, pageNumber) => {
        let that = this
        let currentPage = e && e.target.id == 'previousPage'
            ? pageNumber - 1
            : e && e.target.id == 'nextPage'
                ? pageNumber + 1
                : pageNumber
        let startDate = getParameters('startDate') ? getParameters('startDate') : null
        let endDate = getParameters('endDate') ? getParameters('endDate') : null
        that.getReportsData(this.state.datasetFilterToolId, startDate, endDate, that.state.searchValue, 20, currentPage, that.state.sortBy, that.state.sortOrder, that.state.sortValue, that.state.dashboardFilterName)
    }
    handleSearch = (e, action = null) => {
        let that = this
        let searchKeyword = e.target.value ? e.target.value : document.getElementById('searchKeyword').value
        if (action == 'search' && e && e.target.className == 'input-group-text' || e.key === 'Enter') {
            if (that.state.tabId == 'reports') {
                that.getReportsData(that.state.datasetFilterToolId, null, null, searchKeyword, 20, 1, that.state.sortBy, that.state.sortOrder, that.state.sortValue, that.state.dashboardFilterName)
            } else that.setState({ searchValue: searchKeyword })
        } else if (action == 'remove') {
            document.getElementById('searchKeyword').value = ''
            if (that.state.tabId == 'reports') {
                that.getReportsData(that.state.datasetFilterToolId, null, null, '', 20, 1, that.state.sortBy, that.state.sortOrder, that.state.sortValue, that.state.dashboardFilterName)
            } else that.setState({ searchValue: '' })
        }
    }
    handleSortBy = (e) => {
        let that = this
        let sortVal = e.target.value
        if (that.state.tabId == 'reports') {
            let sortBy = null, sortOrder = null
            if (sortVal == 'alphabetically') {
                sortBy = 'reportName'
                sortOrder = 'asc'
            } else if (sortVal == 'de-alphabetically') {
                sortBy = 'reportName'
                sortOrder = 'desc'
            } else if (sortVal == 'time') {
                sortBy = 'dateModified'
                sortOrder = 'desc'
            } else if (sortVal == 'dataset') {
                sortBy = 'datasetName'
                sortOrder = 'asc'
            } else if (sortVal == 'dashboard') {
                sortBy = 'dashboard_group'
                sortOrder = 'asc'
            }
            that.getReportsData(that.state.datasetFilterToolId, null, null, that.state.searchValue, 20, 1, sortBy, sortOrder, sortVal, that.state.dashboardFilterName)
        } else this.setState({ sortValue: sortVal })
    }
    handleDataset = (e) => {
        let that = this
        let sortVal = that.state.sortValue, sortBy = that.state.sortBy
        if (e.target.value && that.state.sortValue == 'dataset') {
            sortVal = ''
            sortBy = 'reportName'
        }
        if (that.state.tabId == 'reports') {
            that.getReportsData(e.target.value, null, null, that.state.searchValue, 20, 1, sortBy, that.state.sortOrder, sortVal, that.state.dashboardFilterName)
        } else this.setState({ datasetFilterToolId: e.target.value, sortValue: sortVal })
    }

    handleDashboard = (e) => {
        let that = this
        let dashboardVal = e && e.target.value ? e.target.value.split('_') : ''
        let sortVal = that.state.sortValue, sortBy = that.state.sortBy
        if (dashboardVal && that.state.sortValue == 'dashboard') {
            sortVal = ''
            sortBy = 'reportName'
        }
        if (that.state.tabId == 'reports') {
            that.getReportsData(dashboardVal[1] ? dashboardVal[1] : that.state.datasetFilterToolId, null, null, that.state.searchValue, 20, 1, sortBy, that.state.sortOrder, sortVal, e.target.value)
        } else this.setState({ dashboardFilterName: e.target.value, sortValue: sortVal, datasetFilterToolId: dashboardVal[1] })
    }

    globalFilterInputHandler(value) {
        if (Object.keys(this.state.modalToView).length > 0) {
            let formData = (<AsyncSelect
                key={`global_filter_${Math.floor(Math.random() * 10)}`}
                name="global_filter"
                value={value}
                loadOptions={this.fetchFilterValues}
                onChange={this.globalFilterInputHandler}
                cacheOptions={true}
                defaultOptions={true}
                isMulti={true}
                loadingMessage={() => 'Loading options...'} // Message during loading
                noOptionsMessage={() => 'No options available'} // Message if no options found
            />);
            this.state.modalToView.modal['formKey'] = `globalFilterForm_${Math.floor(Math.random() * 10)}`;
            this.setState({ ...this.state, modalToView: { ...this.state.modalToView, formData: formData }, globalFilterValues: value == null ? [] : value })

        } else {

            this.setState({
                globalFilterValues: value == null ? [] : value
            })

        }
    }
    fetchFilterValues = (params, callback) => {
        try {
            asyncFilter(params, null, callback, this.props.authData, null, null, selectedToolData.toolId);
        } catch (error) {
            console.log('-----Error In fetchFilterValues ----')
            console.log(error)
        }
    }
    getGlobalFilters(gridData = null) {
        let that = this;
        selectedToolData = gridData ? gridData : gridOptions.api.getSelectedNodes()[0].data
        let params = {
            siteId: selectedToolData.siteId,
            toolId: selectedToolData.toolId
        }
        
        if (cacheGlobalFilter && cacheGlobalFilter[selectedToolData.toolId]) {
            that.handleGlobalFilter(cacheGlobalFilter[selectedToolData.toolId])

        } else {
            CallAPI('GET', '/app/getGlobalFilter', null, params, 0, function (response) {
                if (response?.value ? response?.value[0] : false) {
                    //  that.setState({
                    let globalFilterValues = response.value[0].temporary_filter && isJson(response.value[0].temporary_filter) ? JSON.parse(response.value[0].temporary_filter) : [];
                    
                    cacheGlobalFilter[selectedToolData.toolId] = globalFilterValues;
                    that.handleGlobalFilter(globalFilterValues)
                    //  globalFilterToolId: toolId
                    //  })
                }else{
                    alert(`Status Code ${response.status} : ${response.statusText}`)
                }
            }, this.props.authData)
        }

    }
    updateGlobalFilters = (e) => {
        e.preventDefault();
        let params = {
            "siteId": this.props.authData.siteId, "toolId": selectedToolData.toolId
        }
        let postData = {
            "userId": this.props.authData.userId, "temporary_filter": this.state.globalFilterValues
        }
        let that=this;
        CallAPI('POST', '/app/setGlobalFilter', postData, params, 0, function (response) {
            if (response.status)
                alert("Filters updated successfully")
            // jQuery('#globalFilterModal').modal('toggle')
            cacheGlobalFilter[selectedToolData.toolId] = that.state.globalFilterValues
            that.props.getGlobalFilters({
                siteId: params.siteId,
                toolId: params.toolId,
                userId: that.props.authData.userId,
                sessionId: that.props.authData.sessionId
            })
            // window.location.reload()
            jQuery('#globalFilterModal').modal('toggle');
        }, this.props.authData)
    }
    handleGlobalFilter = (globalFilterValues = null) => {
        let that = this
        let config = JSON.parse(JSON.stringify(globalFilterModal));
        let propsFilter = that.props.globalFilters.length > 0 ? that.props.globalFilters : []
        let formData = (<AsyncSelect
            key={`global_filter_${Math.floor(Math.random() * 10)}`}
            name="global_filter"
            value={globalFilterValues}
            loadOptions={that.fetchFilterValues}
            onChange={that.globalFilterInputHandler}
            cacheOptions={true}
            defaultOptions={true}
            isMulti={true}
        />);
        config['title'] = <>Global Filter ({selectedToolData.name})</>
        config['formKey'] = `globalFilterForm_${Math.floor(Math.random() * 10)}`;
        that.setState({ ...that.state, modalToView: { modal: config, formData: formData } })
        setTimeout(() => {
            jQuery('#globalFilterModal').modal('toggle');
        }, 5);
    }
    modalCancel = () => {
        this.setState({
            globalFilterValues: this.props.globalFilters ? this.props.globalFilters : []
        })
    }

    render() {
        var that = this, currentTab = that.state.tabId, paginationComp = null, datasetDropdown = null, dashboardDropdown = null, screen_width = jQuery(window).width();
        let url = window.location.href
        let tabsArray = [that.state.tabId]; //removed ['datasets', 'dashboards', "reports"] , if you want you can add these names according to tab in the array
        let isCustomReportingTrue = JSON.parse(this.props.authData.extraInfo)?.customReporting ? JSON.parse(this.props.authData.extraInfo)?.customReporting : false

        minDateCalendar = this.state.data.reportDates?.minStartDate
        maxDateCalendar = this.state.data.reportDates?.maxEndDate
        start_date = that.state.data.reportsData?.startDate
            ? that.state.data.reportsData?.startDate
            : that.state.data.reportDates?.defaultStartDate
        end_date = that.state.data.reportsData?.endDate
            ? that.state.data.reportsData?.endDate
            : that.state.data.reportDates?.defaultEndDate

        var dashboardData = this.props.allDashboards && this.props.allDashboards.dashboardGroupsName ? JSON.parse(JSON.stringify(this.props.allDashboards.dashboardGroupsName)) : this.props.dataSet.dashbordGroupsNames ? JSON.parse(JSON.stringify(this.props.dataSet.dashbordGroupsNames)) : []

        if (currentTab !== 'datasets') {
            if (this.state.datasetFilterToolId && this.props.allDashboards.dashboardGroupsName ) {
                dashboardData = this.props.allDashboards && this.props.allDashboards.dashboardGroupsName.filter((element) => {
                    if (element.toolId == this.state.datasetFilterToolId) {
                        return element;
                    }
                });
            }
            let listofDataSet = [{ "name": "All Datasets", "value": "" }]
            this.props.dataResult && this.props.dataResult.map(innerData => {
                listofDataSet.push({ "name": innerData.name, "value": innerData.toolId })
                // return <option value={innerData.toolId}>{innerData.name}</option>;
            })
            let datasetDropdownData = {
                "dataset_filter": {
                    "name": "dataset_filter", "type": "dropdown", 'options': listofDataSet, "text_value": this.state.datasetFilterToolId, "dropdownHeight": "34px", "key": `datasetKey${Math.floor(Math.random() * 10)}`, multiple: false
                }
            }
            datasetDropdown = <Form label_array={datasetDropdownData} handle_form_drop_down={(e) => this.handleDataset(e)} formGroupClass='mg-b-0' containerClass={"mg-r-10"} formGroupWidth={false} />
        }
        if (currentTab == 'reports') {
            let listofDashboards = [{ "name": "All Dashboards", "value": "" }]
            dashboardData && dashboardData.map(innerData => {
                let workbook_name = `${innerData.dashboard_group} (${innerData.dataset_name})`
                let workbook_value = `${innerData.dashboard_group}_${innerData.toolId}`
                listofDashboards.push({ "name": workbook_name, "value": workbook_value })
                // return <option value={workbook_value}>{workbook_name}</option>;
            })
            let dashboardDropdownData = {
                "dataset_filter": {
                    "name": "dataset_filter", "type": "dropdown", 'options': listofDashboards, "text_value": this.state.dashboardFilterName, "dropdownHeight": "34px", "key": `dashboardKey${Math.floor(Math.random() * 10)}`, multiple: false
                }
            }
            dashboardDropdown = <Form label_array={dashboardDropdownData} handle_form_drop_down={(e) => this.handleDashboard(e)} formGroupClass='mg-b-0' formGroupWidth={false} />

            paginationComp = this.state.data?.reportsData?.totalPages
                ? <div className="d-flex row justify-content-center" style={{ marginTop: 10 }}>
                    <PaginationComponent
                        currentPage={this.state.currentPage}
                        totalPages={this.state.data?.reportsData?.totalPages}
                        paginationEvent={this.paginationEvent}
                    />
                </div>
                : null
        }
        if (currentTab == 'datasets') {
            var filteredDatasetData = JSON.parse(JSON.stringify(this.props.dataResult))
            if (this.state.searchValue) {
                filteredDatasetData = handleSearchData(filteredDatasetData, 'name', this.state.searchValue)
            }
            if (Object.keys(this.state.modalToView).length > 0) {
                this.state.modalToView.modal['body'] = this.state.modalToView.formData ? this.state.modalToView.formData : null
            }
            var globalFilter_modal = this.state.modalToView.modal && Object.keys(this.state.modalToView.modal).length > 0 && <ModalComponent modalConfig={this.state.modalToView.modal} formSubmit={this.updateGlobalFilters} cancelEvent={this.modalCancel} />
        }
        if (currentTab === "dashboards") {
            var filteredDashboardData = JSON.parse(JSON.stringify(dashboardData))
            if (this.state.searchValue) {
                filteredDashboardData = handleSearchData(filteredDashboardData, 'dashboard_group', this.state.searchValue)
            }

        }
        var sortFormVar = {
            "sortByFilter": {
                "name": "sortByFilter",
                "key": `sortKey${Math.floor(Math.random() * 10)}`,
                "type": "dropdown",
                "text_value": this.state.sortValue,
                "options": [
                    { "name": "Sort By", "value": "", selected: true ,},
                    { "name": "A - Z", "value": "alphabetically" },
                    { "name": "Z - A", "value": "de-alphabetically" },
                    // { "name": "Frequently used", "value": "used" },
                    // { "name": "Created date", "value": "created_date" },
                    { "name": "Last updated", "value": "time" }
                ],
                "requiredFlag": false,
                "searchVisibility":false,
                multiple: false
            }
        }
        if (this?.state?.datasetFilterToolId || this.state.tabId == "datasets") {
            sortFormVar['sortByFilter']['options'].push({ "name": "Default", "value": "" })
        } else {
            sortFormVar['sortByFilter']['options'].push({ "name": "By Dataset", "value": "dataset", 'notVisible': 'datasets' }, { "name": "Default", "value": "" })
        }
        var searchInput = {
            "searchInput": { "name": "searchInput", "type": "customSearch","hideRemoveButton":true ,'placeholder': `Search by ${this.state.tabId.charAt(0).toUpperCase() + this.state.tabId.substring(1, this.state.tabId.length - 1)}`, }
        }
        list_users = JSON.stringify(this.props.users);
        let displayData = <LoadingComponent />
        if (this.props.state.loading == false) {
            displayData = !this.state.toggleGridView
                ? <MonitoringTableDataComponent
                    allProps={this.props}
                    allStates={this.state}
                    reportsInfo={this.state.data.reportsData}
                    getReportsData={this.getReportsData}
                    defaultStartDate={start_date}
                    defaultEndDate={end_date}
                    currentTab={this.state.tabId}
                    handleTab={this.handleTabId}
                    handleRightClickOption={this.handleRightClickOption}
                    datasetData={filteredDatasetData}
                    dashboardData={filteredDashboardData}
                    handleGlobalFilter={this.getGlobalFilters}
                />
                : <MonitoringGridComponent
                    allProps={this.props}
                    allStates={this.state}
                    setDataFunction={this.setData}
                    datasetData={filteredDatasetData}
                    dashboardData={filteredDashboardData}
                    handleBreakdown={this.handleTabId}
                    handleRightClickOption={this.handleRightClickOption}
                    handleSortBy={this.handleSortBy}
                    handleGlobalFilter={this.getGlobalFilters}
                />
        }
        return (<div className={` ${currentTab=="dashboards" ? "mobile-mg-t-10" : "mobile-mg-t-30"}`} >
            
            <div className=''>
                {/* tabs  */}
                <ul className="nav nav-line d-flex justify-content-between" id="myTab" role="tablist">
                    {tabsArray.map((routeName, index) => {
                        let tabName = routeName.charAt(0).toUpperCase() + routeName.slice(1)
                        return <li className="nav-item" key={`${routeName}_${index}`}>
                            <a className={`nav-link ${routeName === currentTab ? 'active' : null}`} id={`${routeName}-tab`} data-toggle="tab" href={`#${routeName}`} role="tab" aria-controls={routeName} aria-selected="true" onClick={() => this.handleTabId(routeName)}>{tabName}</a>
                        </li>
                    })}
                    <div className="row d-flex mg-r-1" >
                        <div className="d-flex bd bd-1 pd-y-2 pd-x-2 rounded mg-b-3">
                            {/* <input type="checkbox" className="custom-control-input" key={`-switch`} id={`-switch`} onClick={(e) => this.toggleMainButton(e)} checked={!this.state.toggleGridView} /> */}
                            <div className="icon_hover pd-3" data-toggle="tooltip" title="Grid View" onMouseEnter={() => { jQuery('[data-toggle="tooltip"]').tooltip() }} style={{ cursor: "pointer" }} onClick={(e) => this.toggleMainButton(true)}>

                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={this.state.toggleGridView == false ? 'gray' : '#0168fa'} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid mg-r-10 "><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7" style={{ cursor: "pointer" }} ></rect></svg>

                            </div>
                            <div className='icon_hover pd-3' data-toggle="tooltip" onMouseEnter={() => { jQuery('[data-toggle="tooltip"]').tooltip() }} style={{ cursor: "pointer" }} title="Table View" onClick={(e) => this.toggleMainButton(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={this.state.toggleGridView ? 'gray' : '#0168fa'} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-table "><path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18" ></path></svg>
                            </div>

                            {/* <label className="custom-control-label" htmlFor={`-switch`}>Table View</label> */}
                        </div>
                    </div>
                </ul>
                {/* tab-contents */}
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade active show" id={currentTab} role="tabpanel" aria-labelledby={`${currentTab}-tab`}>
                        <div className="d-flex justify-content-start mg-t-10 " style={{ width: "100%" }}>
                            <div className="d-flex justify-content-between w-100">
                                <div className="d-flex">
                                    <Form label_array={searchInput} onSearch={this.handleSearch} call_back={this.call_back_form} customWidthClass={"customInputWidth w-100"} />
                                    {/* {datasetDropdown} */}
                                    {/* <div className="mg-l-10">
                                    {dashboardDropdown}
                                </div> */}
                                </div>
                                {<div className={`d-flex`} style={{width:"130px"}} >
                                    <div className="home-page w-100">
                                        <Form label_array={sortFormVar} handle_form_drop_down={(e) => this.handleSortBy(e)} formGroupWidth={true} formGroupClass='mg-b-0' allStates={this.state} />
                                    </div>
                                </div>}
                            </div>
                        </div>
                        {displayData}
                        {this.props.state.loading == false ? paginationComp : null}
                    </div>
                </div>
            </div>
            {currentTab == 'datasets' && globalFilter_modal}
        </div>)
    }

}
function mapStateToProps(state) {
    return {
        authData: state.dataSet.authData,
        dataResult: state.dataSet.dataResult,
        dataSet: state.dataSet.dataSet,
        allMetric: state.dataSet.allMetric,
        allProperty: state.dataSet.allProperty,
        allDashboards: state.dataSet.allDashboards || {},
        users: state.dataSet.getAllUsers,
        view: state.dataSet.view,
        tab: state.dataSet.tab,
        globalFilters: state.dataSet.globalFilters,
        initialDataApiFlag: state.dataSet.initialDataApiFlag,
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setData, getData, resetTool, resetAlfredQuestions, handle_restricted_Filter, setKpiColumnConfig, setTab, setGlobalFilters,getGlobalFilters,setQuestion
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(DashBoardMonitoring);